import React from 'react';
import { Link } from 'gatsby';
// eslint-disable-next-line import/no-unresolved
import ranksenseLogo from 'assets/resources/pages/ranksense_logo.png';
import { IoIosArrowRoundForward } from 'react-icons/io';
import OptimizedImage from '../../../OptimizedImage';
import useSitemap from '../../../../graphql/staticQueries/useSitemap';

const DevOpsContenet = () => {
  const pages = useSitemap();
  const desiredPage = '/case-studies/ranksense/';
  const altPage = '/case-studies/';
  const linkTo = pages.includes(desiredPage) ? desiredPage : altPage;
  return (
    <div className="row">
      <div className="col-lg-5 col-mn-12">
        <div className="desc-section">
          <div className="subtitle bigger">Standalone DevOps</div>
          <div className="content">
            <p>
              When your application serves millions of users it needs
              professional attention that will lead to secure and smooth
              processes. We build and create the appropriate infrastructure
              allowing for quick, easy and fast updates.
            </p>
            <p>
              We provide comprehensive DevOps services like containerization,
              microservices, managed Kubernetes, log management, deployment
              automation, continuous integration and continuous delivery.
            </p>
            <p>
              <strong>In practise, you will get:</strong>
            </p>
            <ul>
              <li>Quicker delivery of app updates and releases</li>
              <li>High quality and peak performance of your solution</li>
              <li>Fast response to customer needs</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="col-lg-7 col-md-12">
        <div className="image-section">
          <OptimizedImage
            src="pages/ranksense_photo.png"
            className="img-fluid"
            alt="ranksense photo"
            title="ranksense photo"
          />
          <Link to={linkTo} className="company-link">
            <div className="logo">
              <img
                src={ranksenseLogo}
                className="img-fluid"
                alt="Ranksense logo"
                title="Ranksense logo"
              />
            </div>
            <div className="link">
              <div className="read-more">
                See related project <IoIosArrowRoundForward />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DevOpsContenet;
